export function formatResourceType(resourceType: string): string {
  if (!resourceType) return ''
  return resourceType
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}
